import { Component, OnInit, Input } from '@angular/core';
import { ModalService } from '@ibe/services/ui';
import { INDRAAddExtraModalComponent } from '@ibe.components/shared/add-extra-modal/add-extra-modal.indra.component';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import * as fromStore from '@ibe/store/index';
import { Store } from '@ngrx/store';
import { EXTRAS_ANCILLARY_SEAT,
		EXTRAS_ANCILLARY_BAG,
		EXTRAS_ANCILLARY_EQUIPMENT,
		EXTRAS_ANCILLARY_FAST_TRACK,
		EXTRAS_ANCILLARY_MUSICAL,
		EXTRAS_ANCILLARY_MEAL,
		EXTRAS_ANCILLARY_ANIMAL,
		EXTRAS_ANCILLARY_LOUNGE,	
		SESSION_VAR_KEY_CURRENCY,
		EXTRAS_ANCILLARY_PREF_BOARD} from '@ibe.config';
import { INDRAAddOnAncillary } from '@ibe.models/ancillary.indra.model.lib';
import { INDRAGoogleAnalyticsService, EVENT_ACTION_CLICK } from '@ibe.services/google.analytics.indra.service';


@Component({
	selector: 'app-card-offer-highlight',
	templateUrl: './card-offer-highlight.indra.component.html',
	styleUrls: ['./card-offer-highlight.component.scss'],
	host: {
		class: 'app-card-offer-highlight'
	},
})
export class INDRACardOfferHighlightComponent implements OnInit {
	@Input() extra: any = null;
	@Input() extraID: string;
	@Input() title: string;
	@Input() subtitle: string = null;
	@Input() name: string;
	@Input() image: string;
	@Input() isLoading: boolean = true;
	@Input() isAdded: boolean = false;
	@Input() flightDetails: any = null;
	
	@Input() externalLink: any = null;
	@Input() logo: any = null;

	price: string;
	extraDescription: string;

	constructor(
		private store: Store<fromStore.State>,
		private modalService: ModalService,
		private googleAnalytics: INDRAGoogleAnalyticsService) { }

	ngOnInit() {
		// TO DO - change to switch
		if (!this.title) {
			if (this.extra.type == EXTRAS_ANCILLARY_SEAT) {
				this.title = 'bookingDetails.text.EconomyXtraSeatsBannerTitle';
				this.subtitle = 'bookingDetails.text.EconomyXtraSeatsBannerSubTitle';
				this.image = './assets/images/ancillaries/offers/3.jpg';
				this.name = 'review.cardOffer.text.seats';
			} else if (this.extra.type == EXTRAS_ANCILLARY_BAG) {
				this.title = 'bookingDetails.text.EconomyXtraBagsBannerTitle';
				this.subtitle = 'bookingDetails.text.EconomyXtraBagsBannerSubTitle';
				this.image = './assets/images/ancillaries/offers/1.jpg';
				this.name = 'review.cardOffer.text.checkedBags';
			} else if (this.extra.type == EXTRAS_ANCILLARY_EQUIPMENT) {
				this.title = 'review.cardOffer.text.sportsEquipment';
				this.subtitle = null;
				this.image = './assets/images/ancillaries/offers/5.jpg';
				this.name = 'review.cardOffer.text.sports';
			} else if (this.extra.type == EXTRAS_ANCILLARY_FAST_TRACK) {
				this.title = 'bookingDetails.text.EconomyXtraFastTrackBannerTitle';
				this.subtitle = 'bookingDetails.text.EconomyXtraFastTrackBannerSubTitle';
				this.image = './assets/images/ancillaries/offers/2.jpg';
				this.name = 'review.cardOffer.text.fastTrack';
			} else if (this.extra.type == EXTRAS_ANCILLARY_MUSICAL) {
				this.title = 'review.cardOffer.text.musicalInstruments';
				this.subtitle = null;
				this.image = './assets/images/ancillaries/offers/music.jpg';
				this.name = 'review.cardOffer.text.musical';
			} else if (this.extra.type == EXTRAS_ANCILLARY_MEAL) {
				this.title = 'review.cardOffer.text.chooseSpecialMeal';
				this.subtitle = null;
				this.image = './assets/images/ancillaries/offers/6.jpg';
				this.name = 'review.cardOffer.text.meal';
			} else if (this.extra.type == EXTRAS_ANCILLARY_ANIMAL) {
				this.title = 'review.cardOffer.text.smallPets';
				this.subtitle = null;
				this.image = './assets/images/ancillaries/offers/pets.jpg';
				this.name = 'review.cardOffer.text.smallPets';
			} else if (this.extra.type == EXTRAS_ANCILLARY_LOUNGE) {
				this.title = 'review.cardOffer.text.premiumService';
				this.subtitle = null;
				this.image = './assets/images/ancillaries/offers/4.jpg';
				this.name = 'review.cardOffer.text.lounge';
			} else if (this.extra.type == EXTRAS_ANCILLARY_PREF_BOARD) {
				this.title = 'review.cardOffer.text.prefBoardTitle';
				this.subtitle = 'review.cardOffer.text.prefBoardSubtitle';
				this.image = './assets/images/ancillaries/offers/preferredBoard.jpg';
				this.name = 'review.cardOffer.text.prefBoardName';
			}
		}

		if (this.flightDetails != null) {

		}

		if (this.extra.description !== 'for free') {
			const description = this.extra.description.split(' ');
			this.price = description[1] + ' ' + description [2];
			this.extraDescription = description[0];
		} else {
			this.extraDescription = 'forFree';
		}
	}

	INDRA_openExtra() {
		const ID = this.extraID;
		this.store.dispatch(new ConfirmModalActions.PutTitle(this.name));
		this.modalService.assignComponent(INDRAAddExtraModalComponent, { feature: ID, flightDetails: this.flightDetails });
		this.modalService.open();
		this.INDRA_registerGAClickExtra();
	}

	INDRA_registerGAClickExtra() {
		const ID = this.extraID;
		const extra = this.flightDetails.map(flight => flight.ancillaries.find(ancillary => ancillary.id === ID)).find(x => x);
		if (extra) {
			const product = { code: extra.type } as INDRAAddOnAncillary;
			const eventDataLayerObject = this.googleAnalytics.IBE_createGA_AncillaryProducts(product, extra.name);
			eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_CLICK);
			this.googleAnalytics.INDRA_GA_productClick(eventDataLayerObject, sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY));
		}
	}

}
